import { defineType } from "sanity";

export default defineType({
  name: "ctaButtons",
  type: "array",
  title: "CTA Buttons",
  of: [
    { type: "pageCTA" },
    { type: "raqCTA" },
    { type: "sfoCTA" },
    { type: "brochureCTA" },
    { type: "linkCTA" },
    { type: "fycLinkCTA" },
    { type: "fileCTA" },
    { type: "videoCTA" },
    { type: "anchorCTA" },
    { type: "phoneNumberCTA" }
  ]
});
